import { useState } from "react";

import Navigation from "@/components/Navigation/Navigation";
import PatientDetailsPageHeader from "@/components/PatientDetailsPageHeader/PatientDetailsPageHeader";
import UsersDetailsPageMain from "@/components/UsersDetailsPageMain/UsersDetailsPageMain";
import useSelectedPatient from "@/hooks/useSelectedPatient";
import UsersDrawerAddUser from "@/components/UsersDrawerAddUser/UsersDrawerAddUser";

export default function UserDetailsPage() {
    const [open, setOpen] = useState<boolean>(false);

    useSelectedPatient();
    const isEditEntity = true;

    function toggleDrawer(isOpen: boolean): void {
        setOpen(isOpen);
    }

    return (
        <div className='container patients_container'>
            <Navigation />
            <PatientDetailsPageHeader />
            <UsersDetailsPageMain toggleDrawer={toggleDrawer} />
            <UsersDrawerAddUser
                toggleDrawer={toggleDrawer}
                open={open}
                isEditEntity={isEditEntity}
            />
        </div>
    );
}
